export { default as FlagIcon } from './FlagIcon';
